<div
	class="d-inline-flex align-items-center position-relative"
	[ngClass]="{
		'hovered': isHovered
	}"
	(mouseenter)="isHovered = true"
	(mouseleave)="isHovered = false"
>

	<!-- Icon, Date Label -->
	<div
		class="row gx-0 mx-auto cursor-pointer align-items-center"
		(click)="toggle()"
	>

		<!-- Icon -->
		<i
			class="col-auto icon-calendar date-picker-icon-color fs-xl"
			[ngClass]="{
				'order-1': positionLabel === positionEnum.LEFT && showDateLabel,
				'order-0': positionLabel === positionEnum.RIGHT && showDateLabel
			}"
		></i>

		<!-- Date Label -->
		<span
			*ngIf="showDateLabel"
			class="col month-picker-label fs-medium fw-regular"
			[ngClass]="{
				'order-0 me-3': positionLabel === positionEnum.LEFT,
				'order-1 ms-3': positionLabel === positionEnum.RIGHT
			}"
		>
			{{ replaceEmptyValue( getLocaleDateString( selectedDate, dateFormat ) ) }}
		</span>
	</div>

	<!-- Picker Menu -->
	<div
		*ngIf="isOpen"
		class="month-picker fs-md text-start p-1"
		[ngClass]="{
			'position-left': positionPickerMenu === positionEnum.LEFT,
			'position-right': positionPickerMenu === positionEnum.RIGHT
		}"
	>

		<!-- Header -->
		<div class="formElementWrapper month-picker-header">
			<ng-container [ngTemplateOutlet]="pickerMenuHeaderTpl"></ng-container>
		</div>

		<!--  Body -->
		<div class="month-picker-body cursor-default">

			<!-- Month Items -->
			<ng-container
				*ngIf="showMonthItems"
				[ngTemplateOutlet]="pickerMenuMonthItemsTpl"
			></ng-container>

			<!-- Date Preselection -->
			<ng-container
				*ngIf="preselectedDateList?.length"
				[ngTemplateOutlet]="pickerMenuDatePreselectionTpl"
			></ng-container>
		</div>
	</div>
</div>

<!-- ######################### TEMPLATES ######################### -->
<!-- Header -->
<ng-template #pickerMenuHeaderTpl>
	<ng-container [ngTemplateOutlet]="pickerMenuYearItemsTpl"></ng-container>
</ng-template>

<!-- Year Items -->
<ng-template #pickerMenuYearItemsTpl>

	<!-- Year readonly -->
	<ng-container *ngIf="readOnlyYear">
		<div class="border-bottom-2 border-bottom text-center fw-medium year-label">
			{{ activeYear }}
		</div>
	</ng-container>

	<!-- Year Items -->
	<ng-container *ngIf="!readOnlyYear">
		<div class="year-items row gx-2">

			<!-- Prev Button -->
			<div class="col-3">
				<button
					type="button"
					class="btn btn-link"
					[ngClass]="{'disabled': isYearSmallerMinYear(activeYear - 1)}"
					[disabled]="isYearSmallerMinYear(activeYear - 1)"
					(click)="prevYear()"
				>
					<app-svg
						[size]="svgSizeEnum.MEDIUM"
						[type]="svgTypeEnum.CHEVRON_LEFT"
					></app-svg>
				</button>
			</div>

			<!-- Year -->
			<div
				class="col text-center inputWrapper"
				[ngClass]="{'disabled': yearList?.length < 2}"
			>
				<div
					#yearDrop="ngbDropdown"
					data-e2e-dropdown
					display="dynamic"
					ngbDropdown
					placement="bottom"
				>

					<div
						class="input fs-24"
						ngbDropdownToggle
					>{{ activeYear }}</div>

					<div class="dropdown" ngbDropdownMenu>
						<button
							*ngFor="let yearItem of yearList"
							type="button"
							class="btn btn-link d-block no-background year-item"
							[ngClass]="{
								'disabled': yearItem?.disabled,
								'selected pe-none': activeYear === yearItem?.year
							}"
							[disabled]="yearItem?.disabled"
							(click)="yearDrop.close(); selectYear(yearItem?.year);"
						>{{ yearItem?.year }}</button>
					</div>
				</div>
			</div>

			<!-- Next Button -->
			<div class="col-3">
				<button
					type="button"
					class="btn btn-link"
					[ngClass]="{'disabled': isYearGreaterEqualMaxYear(activeYear + 1)}"
					[disabled]="isYearGreaterEqualMaxYear(activeYear + 1)"
					(click)="nextYear()"
				>
					<app-svg
						[size]="svgSizeEnum.MEDIUM"
						[type]="svgTypeEnum.CHEVRON_RIGHT"
					></app-svg>
				</button>
			</div>
		</div>
	</ng-container>
</ng-template>

<!-- Month Items -->
<ng-template #pickerMenuMonthItemsTpl>
	<button
		*ngFor="let entrance of monthNumberList; let month = index"
		class="month-item col-3 p-0 text-center fs-md align-middle"
		[ngClass]="{
			'selected pe-none': selectedYearMonth === activeYear + '' + month,
			'disabled': isMonthSmallerMinMonth(month) || isMonthGreaterEqualMaxMonth(month)
		}"
		[disabled]="isMonthSmallerMinMonth(month) || isMonthGreaterEqualMaxMonth(month)"
		(click)="selectMonth(month); isHovered = false"
	>
		{{
		getI18nString( false, 'datepicker.monthShortName.month' + (
													month + 1
		) )
		}}
	</button>
</ng-template>

<!-- Date Preselection -->
<ng-template #pickerMenuDatePreselectionTpl>
	<div class="d-flex flex-column border-top pt-2 month-picker-preselection-wrapper">

		<!-- Label -->
		<p class="fw-regular fs-sx mb-1 month-picker-preselection-label">
			{{ this.getI18nString( false, 'monthpicker.preselection.label' ) }}
		</p>

		<!-- ButtonGroup -->
		<div
			class="btn-group btn-group-toggle btn-group-vertical"
			data-toggle="buttons"
		>
			<!-- ButtonItem (TODO: Sonar is whining about it to be a label element, so consider to make it a button element, also because it IS a button) -->
			<label
				*ngFor="let preselectionDateItem of preselectedDateList"
				class="btn btn-secondary fw-regular text-nowrap"
				[ngClass]="{
				'disabled': preselectionDateItem?.disabled,
				'active': preselectionDateItem?.isActive
				}"
				(click)="onPreselectedDateSelection(preselectionDateItem)"
			>
				{{ preselectionDateItem?.label }}
			</label>
		</div>
	</div>
</ng-template>
